import type { Bucket } from '@/entities/bucket';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getBuckets = (
  params?: RequestMeta,
): Promise<{ buckets: Bucket[]; meta: ResponseMeta }> =>
  request({
    url: '/buckets/',
    params,
  });
